<template>
  <button
    ref="toggleButton"
    class="relative w-40 h-40 z-20"
    :aria-expanded="isNavOpen"
    :aria-label="$t('navigation-menu')"
    @click="toggleNav()"
  >
    <div class="hamburger" :class="{ 'nav-open': isNavOpen }">
      <div></div>
    </div>
  </button>
</template>

<script setup>
  import { ref } from 'vue'

  const emit = defineEmits(['toggle'])
  const isNavOpen = ref(false)
  const toggleButton = ref(false)
  const toggleNav = () => {
    isNavOpen.value = !isNavOpen.value
    emit('toggle')
    toggleButton.value.focus()
  }
  const handleEsc = () => {
    if (isNavOpen.value) toggleNav()
  }
  defineExpose({ handleEsc })
</script>

<style>
  .hamburger {
    position: absolute;
    top: 0;
    left: 0;
    height: 40px;
    width: 40px;

    /* FOR DISPLAYING EVERY ELEMENT IN THE CENTER : */

    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* CREATING THE MIDDLE LINE OF THE HAMBURGER : */

  .hamburger > div {
    position: relative;
    top: 0;
    left: 0;
    height: 2px;
    width: 40px;
    @media (max-width: 480px) {
      width: 24px;
    }
    transition: all 0.4s ease;
  }

  .green-theme .hamburger > div {
    background: var(--f-honkburgundy-800);
  }

  .white-theme .hamburger > div {
    background: var(--f-honkburgundy-800);
  }

  /* CREATING THE TOP AND BOTTOM LINES :
TOP AT -10PX ABOVE THE MIDDLE ONE AND BOTTOM ONE IS 10PX BELOW THE MIDDLE: */

  .hamburger > div::before,
  .hamburger > div::after {
    content: '';
    position: absolute;
    top: -10px;
    width: 100%;
    height: 2px;
    transition: all 0.4s ease;
    left: 0;
  }

  .white-theme .hamburger > div::before,
  .white-theme .hamburger > div::after {
    background: var(--f-honkburgundy-800);
  }

  .green-theme .hamburger > div::before,
  .green-theme .hamburger > div::after {
    background: var(--f-honkburgundy-800);
  }

  .hamburger > div::after {
    top: 10px;
  }

  /* WHEN NAVIGATION IS OPEN THEN SETTING THE BACKGROUND OF THE MIDDLE LAYER TO COMPLETE BLACK AND OPAQUE :  */

  .hamburger.nav-open > div {
    background: rgba(0, 0, 0, 0);
  }

  .hamburger.nav-open > div::before {
    top: 0;
    transform: rotate(45deg);
  }

  /* AND ROTATING THE TOP AND BOTTOM LINES :  */

  .hamburger.nav-open > div::after {
    top: 0;
    transform: rotate(135deg);
  }
</style>
